import { TweenLite } from "gsap";
import { LogGroup, Size, Log, now } from "../.././MyHelpers";
import { Acceleration } from "./Acceleration";
import { Anticipation } from "./Anticipation";
import { AnticipationParams } from "./AnticipationParams";
import { ConstantSpeed } from "./ConstantSpeed";
import { Decceleration } from "./Decceleration";
import { Overshoot } from "./Overshoot";
import { SpinTargetParams } from "./SpinTargetParams";
import { ChangeSpeedParams } from "../SlotGameType1";
import { SpinAnimParams } from "../../SpeedManager";
import { PlayWindow } from "../../api";

export enum ReelSpinAnimState {
	Created,

	Idle,
	Acceleration,
	ConstantSpeed,
	// standard delay
	Delay,
	// anticipation delay is shorter delay, so we can start anticipation in the last interval
	AnticipationDelay,
	Anticipation,
	Decceleration,
	Overshoot,

	Finished,
}

export class OnDeccelerationParams {

	// remaining distance from current position to end
	//distanceToEnd: number = 0;

	// total calculated animation spin distance from beginning to end
	totalDistance: number = 0;
	totalDistanceInSymbols: number = 0;

	constructor(totalDistance: number, totalDistanceInSymbols: number) {
		this.totalDistance = totalDistance;
		this.totalDistanceInSymbols = totalDistanceInSymbols;
	}
}

export interface UpdateParams
{
	distancePixels,
	distanceSymbols,
	translatePixels
}

export type UpdateHandler = (animation: ReelSpinAnimation, params: UpdateParams) => void;

export class ReelSpinAnimation {

	private logGroup: LogGroup = null;
	private reelIndex: number = 0;
	//private symbolHeight: number = 0;
	//private reelWindowHeight: number = 0;

	private state: ReelSpinAnimState = ReelSpinAnimState.Created;
	private startTime: number = 0;

	private lastStateTime: number = 0;
	private lastStateDistance: number = 0;

	private acceleration: Acceleration = null;
	private constantSpeed: ConstantSpeed = null;
	private anticipation: Anticipation = null;
	private decceleration: Decceleration = null;
	private overshoot: Overshoot = null;

	private nearCompleteDistance: number = 0;
	private nearCompleteTargetDistance: number = 0;;
	private nearCompleteTriggeredFlag: boolean = false;

	// where do we stop at?
	private targetSet: boolean = false;
	private stopRequest: boolean = false;
	private reqAnticipation: boolean = false;

	private distance: number = 0;
	// at what distance do we splice animation to target reel position
	private spliceDistance: number = 0;


	private onStartCallbacks: (() => void)[] = [];
	private onCompleteCallbacks: (() => void)[] = [];
	//private onStopAvailableCallbacks: ((reelIndex: number) => void)[] = [];
	//private onUpdateCallbacks: (() => void)[] = [];
	public OnUpdateCallback: UpdateHandler = null;

	public onAnticipationBeginCallbacks: ((e: AnticipationParams) => void) = null;
	public onAnticipationEndCallbacks: ((e: AnticipationParams) => void) = null;

	private previousReelSpinEnded: boolean = false;

	private symbolSize: Size = null;
	private windowSize: Size = null;
	private windowSymbolSize: PlayWindow = null;
	private extendedWindowSymbolSize: Size = null;

	readonly symbolHeight: number = 0;

	public constructor(reelIndex: number, logGroup: LogGroup, symbolSize: Size, windowSize: Size, windowSymbolSize: PlayWindow, extendedWindowSymbolSize: Size, speedFactor: number = 1, duration: number = 0, delay: number = 0, speedCorrection: number = 1) {

		this.reelIndex = reelIndex;

		this.logGroup = logGroup.Add(["ReelSpinAnim", "" + this.reelIndex]);

		this.symbolSize = symbolSize;
		this.windowSize = windowSize;
		this.windowSymbolSize = windowSymbolSize;
		this.extendedWindowSymbolSize = extendedWindowSymbolSize;

		//this.symbolHeight = symbolHeight;
		//this.reelWindowHeight = reelWindowHeight;
		this.symbolHeight = Math.round(this.symbolSize.Height);

		this.CalculateAnimation(duration,delay,speedCorrection);

	}

	private CalculateAnimation(duration: number, delay: number, speedCorrection: number)
	{
		this.acceleration = new Acceleration(this.logGroup);
		this.constantSpeed = new ConstantSpeed(this.logGroup);
		this.anticipation = new Anticipation(this.logGroup);
		this.decceleration = new Decceleration(this.logGroup);
		this.overshoot = new Overshoot(this.logGroup);
		

		/*
		 *	Acceleration
		 */
		let acceleration: Acceleration = new Acceleration(this.logGroup);
		this.acceleration = acceleration;


		// target reel speed in pixles/second? - in milliseconds, now() returns time in millis
		//acceleration.targetSpeed = speed;
		//if (speed == 0)
		acceleration.targetSpeed = 0.040 * this.symbolHeight * speedCorrection;

		// in what distance should we achieve target speet?x
		acceleration.targetDistance = 0.5 * this.symbolHeight;

		// how long will the animation took?
		acceleration.duration = 2 * acceleration.targetDistance / Math.abs(acceleration.targetSpeed);

		// acceleration
		acceleration.acceleration = acceleration.targetSpeed / acceleration.duration;


        /*
         *  Constant speed
         */
		let constantSpeed: ConstantSpeed = new ConstantSpeed(this.logGroup);
		this.constantSpeed = constantSpeed;

		constantSpeed.speed = acceleration.targetSpeed;

		// default distance, if not stopped and target set on time
		constantSpeed.minimumDistance = 7 * this.symbolHeight;
		constantSpeed.defaultDistance = 14 * this.symbolHeight;
		constantSpeed.targetDistance = 0;

		if (constantSpeed.defaultDistance < constantSpeed.minimumDistance)
			constantSpeed.defaultDistance = constantSpeed.minimumDistance;

		if(duration != 0)
		{
			constantSpeed.defaultDistance = Math.round((constantSpeed.speed * duration)/ this.symbolHeight) * this.symbolHeight;
		}
		// how far did we actually travel
		constantSpeed.currentDistance = 0;

		// delay for staggered stops, only used if spin is not interrupted
		//debugger;
		constantSpeed.delayDuration = 250.0 * this.reelIndex;
		if(delay != 0)
		{
			constantSpeed.delayDuration = delay * this.reelIndex;
		}

		constantSpeed.delayDistance = Math.max(
            this.reelIndex * this.symbolHeight, 
            Math.round((constantSpeed.speed * constantSpeed.delayDuration) / this.symbolHeight) * this.symbolHeight
        );
		constantSpeed.delayDuration = constantSpeed.delayDistance / constantSpeed.speed;

        constantSpeed.Reset();
        //// Log.Debug(this.logGroup.Add("constantSpeedTargetDuration"), "" + this.constantSpeed.targetDuration);

        /*
         *	Anticipation
         *  	first set approx duration of anticipation, 
         *		then calculate distance, to match symbol height, 
         *		then calculate back exact duration, based on distance
         */
		this.anticipation.speed = 1 * this.constantSpeed.speed;
		this.anticipation.defaultDuration = 2000.0;
		this.anticipation.defaultDistance = Math.round((this.anticipation.speed * this.anticipation.defaultDuration) / this.symbolHeight) * this.symbolHeight;
		this.anticipation.defaultDuration = this.anticipation.defaultDistance / this.anticipation.speed;
		this.anticipation.Reset();


		/*
	 *	Decceleration, overshoot
	 */
		let decceleration: Decceleration = new Decceleration(this.logGroup);
		this.decceleration = decceleration;
		decceleration.startingSpeed = this.constantSpeed.speed;
		decceleration.overshootDistance = 0.125 * this.symbolHeight;
		decceleration.distance = 0.5 * this.symbolHeight;
		decceleration.targetDistance = decceleration.distance + decceleration.overshootDistance;
		decceleration.duration = 2 * decceleration.targetDistance / decceleration.startingSpeed;
		decceleration.decceleration = -1 * decceleration.startingSpeed / decceleration.duration;



        /*
         *	Near complete - when symbols are slowing down and are visible, maybe 1 symbol left?
         */
		this.nearCompleteTargetDistance = decceleration.distance; //(this.windowSymbolSize.height -1) * this.symbolSize.height;

        /*
         *	Overshoot correction, constant speed return
         */
		let overshoot: Overshoot = new Overshoot(this.logGroup);
		this.overshoot = overshoot;
		overshoot.distance = decceleration.overshootDistance;
		overshoot.speed = acceleration.targetSpeed / 20;
		overshoot.duration = overshoot.distance / overshoot.speed;

	}

	// Changing internal states
	// Each state has OnStateBegin and OnStateEnd in this class
	// TODO change to statemachine class
	private ChangeState(newState: ReelSpinAnimState, silent: boolean = false) {
		let oldStateName = ReelSpinAnimState[this.state];
		let oldStateEndFuncName = "On" + oldStateName + "End";

		let selfCallback: any = this[oldStateEndFuncName];

		if (!silent && this[oldStateEndFuncName] != null) {
			this[oldStateEndFuncName]();
		}

		// Log.Debug(this.logGroup, "ChangeState(newState=" + ReelSpinAnimState[newState] + ")");
		this.state = newState;
		this.lastStateTime = this.Now();

		let newStateName = ReelSpinAnimState[this.state];
		let newStateBeginFuncName = "On" + newStateName + "Begin";

		if (!silent && this[newStateBeginFuncName] != null) {
			this[newStateBeginFuncName]();
		}
	}

	// support changing time speed
	protected prevTime: number = now();
	protected currentTime: number = 0;


	protected readonly normalSpeedFactor: number = 1.5;
	protected readonly acceleratedSpeedFactor: number = 6;
	protected speedFactor: number = this.normalSpeedFactor;
	
	// go from normal time factor to accelerated time factor in 0.05seconds (short time - fast response);
	protected warpSpeedAnim: TweenLite = TweenLite.fromTo(this, 0.05, {speedFactor: this.normalSpeedFactor}, {speedFactor: this.acceleratedSpeedFactor});

	protected Now() {
		let actualTime = now();
		this.currentTime += (actualTime - this.prevTime) * this.speedFactor;

		this.prevTime = actualTime;
		return this.currentTime;
	}


	protected updateParams: UpdateParams = 
	{
		distancePixels: 0,
		distanceSymbols: 0,
		translatePixels: 0
	};

	public Update() {

		// TODO must call update beacause of overlays!
		if (this.state == ReelSpinAnimState.Idle)
		{
			// nothing to update
			//return;
		}

		let time: number = this.Now();
		let timeSinceLastState: number;
		timeSinceLastState = (time - this.lastStateTime);

		if (this.state == ReelSpinAnimState.Created)
		{
			// force first time update
			this.ChangeState(ReelSpinAnimState.Idle, true);
		}

		if (this.state == ReelSpinAnimState.Acceleration) {

			// // Log.Debug("ACC", "t: " + timeSinceLastState + ", duration: " + timeSinceLastState + ", targetDuration: " + this.acceleration.duration);

			if (timeSinceLastState >= this.acceleration.duration) {
				// how far did we travel in this anim
				this.lastStateDistance += this.acceleration.targetDistance;
				this.ChangeState(ReelSpinAnimState.ConstantSpeed);
			}
			else {
				// how far did we travel till now
				this.distance = this.lastStateDistance + this.acceleration.CalculateDistance(timeSinceLastState);
			}
		}

		timeSinceLastState = time - this.lastStateTime;

		if (this.state == ReelSpinAnimState.ConstantSpeed) {

			let distance: number = this.constantSpeed.CalculateDistance(timeSinceLastState);
			this.constantSpeed.currentDistance = distance;

			// // Log.Debug("CONST", "t: " + timeSinceLastState + ", target: " + this.target + "; distance: " + distance +  "; targetDistance: " + this.constantSpeed.targetDistance + ";");

			// if (!this.constantSpeed.passedMinimumDistance && distance >= this.constantSpeed.minimumDistance) {
			// 	// just passed minimum distance, notify that stop request is now available
			// 	this.constantSpeed.passedMinimumDistance = true;

			// 	// as far as travel distance, stop request is available, 
			// 	this.OnStopAvailable();
			// }


            // // console.log(this.logGroup.Name + "_ConstantSpeed", {
            //     targetSet: this.targetSet,
            //     timeSinceLastState: timeSinceLastState,
            //     targetDuration: this.constantSpeed.targetDuration,
                
            //     previousReelSpinEnded: this.previousReelSpinEnded,
            //     reqAnticipation: this.reqAnticipation,
            //     reelIndex: this.reelIndex,
            //     stopRequest: this.stopRequest,


            //     firstcond: this.targetSet,
            //     secondCond: timeSinceLastState >= this.constantSpeed.targetDuration,
            //     thirdCond: this.previousReelSpinEnded || !this.reqAnticipation || this.reelIndex == 0,
            //     fourthCond: this.stopRequest,
            // });


            // let haveTarget: boolean = this.targetSet;
            // let earlyStopRequested: boolean = this.stopRequest;

            // //let isRegularSpin: boolean = this.previousReelSpinEnded && !this.reqAnticipation && this.reelIndex == 0;
            // let isAnicipation: boolean = this.reqAnticipation;
            
            // let timeToEndSpin: boolean = earlyStopRequested || timeSinceLastState >= (this.constantSpeed.targetDuration + this.constantSpeed.delayDuration);
            
            // let endRegularSpin: boolean = timeToEndSpin; // && isRegularSpin;
            // let endAnticipation: boolean =  isAnicipation;


            
            
            
            if (this.targetSet && timeSinceLastState >= this.constantSpeed.targetDuration)
            {
				// Log.Debug(this.logGroup, `timeSinceLastState: ${timeSinceLastState}, targetDuration: ${this.constantSpeed.targetDuration}, defaultDuration: ${this.constantSpeed.delayDuration}`);

				//debugger;
				// if we have anticipation, wait for previous reel to stop
				this.lastStateDistance += this.constantSpeed.targetDistance;

				if (this.reqAnticipation && !this.stopRequest)
                {
					this.ChangeState(ReelSpinAnimState.Anticipation);
                    this.onAnticipationBeginCallbacks?.({
                        reelIndex: this.reelIndex
                    });
				}
				else
                {
					this.ChangeState(ReelSpinAnimState.Decceleration);

                    this.onNearComplete?.(this.reelIndex);
				}
			}
			else {
				this.distance = this.lastStateDistance + distance;
			}
		}

		timeSinceLastState = time - this.lastStateTime;

		// TODO anticipation can be requested to stop early
		if (this.state == ReelSpinAnimState.Anticipation) {
			let distance: number = this.anticipation.CalculateDistance(timeSinceLastState);
			this.anticipation.currentDistance = distance;

			// // Log.Debug("ANTICIPATION", "t: " + timeSinceLastState + "; distance: " + distance +  "; targetDistance: " + this.anticipation.targetDistance + ";");
			if (timeSinceLastState >= this.anticipation.targetDuration) {
				this.lastStateDistance += this.anticipation.targetDistance;
				this.ChangeState(ReelSpinAnimState.Decceleration);
                this.onAnticipationEndCallbacks({
                    reelIndex: this.reelIndex
                });

                this.onNearComplete?.(this.reelIndex);
			}
			else {
				// how far did we travel till now
				this.distance = this.lastStateDistance + distance;
			}
		}

		timeSinceLastState = time - this.lastStateTime;

		if (this.state == ReelSpinAnimState.Decceleration) {

			let distance: number = this.decceleration.CalculateDistance(timeSinceLastState);

			// // Log.Debug("DECC", "t: " + timeSinceLastState + "; distance: " + distance +  "; targetDistance: " + this.decceleration.targetDistance + ";");


			/*
			if (this.nearCompleteDistance >= distance && !this.nearCompleteTriggeredFlag) {
				this.nearCompleteTriggeredFlag = true;
				this.OnNearComplete();
			}
			*/

			if (timeSinceLastState >= this.decceleration.duration) {
				this.lastStateDistance += this.decceleration.targetDistance;

				this.ChangeState(ReelSpinAnimState.Overshoot);
			}
			else {
				// how far did we travel till now
				this.distance = this.lastStateDistance + distance;
			}
		}

		timeSinceLastState = time - this.lastStateTime;

		if (this.state == ReelSpinAnimState.Overshoot) {

			let distance: number = -1 * this.overshoot.CalculateDistance(timeSinceLastState);

			// // Log.Debug("OVER", "t: " + timeSinceLastState + "; distance: " + distance +  "; targetDistance: " + this.overshoot.distance + "; duration: " + this.overshoot.duration);

			if (timeSinceLastState >= this.overshoot.duration) {
				this.lastStateDistance -= this.overshoot.distance;

				// this is the last state, so set exact distance
				this.distance = this.lastStateDistance;

				// spin is finished
				this.ChangeState(ReelSpinAnimState.Finished);
			}
			else {
				this.distance = this.lastStateDistance + distance;
			}
		}

		if (this.state == ReelSpinAnimState.Finished)
		{
			//let symbolsDistance = Math.round(this.distance / this.symbolSize.height) * this.symbolSize.height;
			//let distance = Math.round(symbolsDistance * 1000) / 1000;

			this.distance = Math.round(this.distance / this.symbolHeight) * this.symbolSize.Height;

			this.ChangeState(ReelSpinAnimState.Idle);
		}

		{
			this.updateParams.distancePixels = Math.roundTo((this.distance), 3);
			this.updateParams.distanceSymbols = Math.floor((this.distance) / this.symbolHeight);
			this.updateParams.translatePixels = this.updateParams.distancePixels - (this.updateParams.distanceSymbols * this.symbolHeight);
		}

		this.OnUpdateCallback?.(this, this.updateParams);
	}

	public Start(): void {
		if (this.state == ReelSpinAnimState.Idle) {
			//// Log.Debug(this.logGroup, "Starting");

			// clear everything, before changing state
			this.Reset();
			this.ChangeState(ReelSpinAnimState.Acceleration);
		}
		else {
			// Log.Debug(this.logGroup, "Already running");
		}
	}

	private Reset(): void
	{
		this.targetSet = false;
		this.stopRequest = false;
		this.reqAnticipation = false;
		this.constantSpeed.Reset();
		this.anticipation.Reset();
		this.lastStateDistance = 0;
		this.distance = 0;

		this.speedFactor = this.normalSpeedFactor;
		this.warpSpeedAnim.kill();

		this.nearCompleteTriggeredFlag = false;

		// first reel has no previous reels
		if (this.reelIndex == 0) {
			this.previousReelSpinEnded = true;
		}
		else {
			this.previousReelSpinEnded = false;
		}
	}

	public Cancel(): void
	{
		this.ChangeState(ReelSpinAnimState.Idle);
		this.Reset();
		
		this.updateParams.distancePixels = 0;
		this.updateParams.distanceSymbols = 0;
		this.updateParams.translatePixels = 0;
		this.OnUpdateCallback?.(this, this.updateParams);
	}

	public Stop(): void {

	}

	// public AddOnUpdateCallback(callback: () => void): void {
	// 	this.onUpdateCallbacks.push(callback);
	// }

	// private OnUpdate(): void {
	// 	for (let i = 0; i < this.onUpdateCallbacks.length; i++) {
	// 		this.onUpdateCallbacks[i]();
	// 	}
	// }

	public AddOnStopAvailableCallback(callback: (reelIndex: number) => void) {
		//this.onStopAvailableCallbacks.push(callback);
	}

	// public CheckStopAvailable(): boolean {
	// 	let available: boolean = false;

	// 	// stop request is available, if target is set and minimum distance has been traveled
	// 	//if (this.targetSet && this.constantSpeed.passedMinimumDistance) {
	// 	if (this.targetSet) {
	// 		available = true
	// 	}
	// 	else {
	// 		// stop request not yet available
	// 	}

	// 	return available;
	// }

	// private OnStopAvailable(): void {
	// 	if (this.CheckStopAvailable()) {

	// 		//// Log.Debug(this.logGroup, "Stop request is now available, notifying");

	// 		for (let i = 0; i < this.onStopAvailableCallbacks.length; i++) {
	// 			this.onStopAvailableCallbacks[i](this.reelIndex);
	// 		}
	// 	}
	// }

    public onNearComplete: (reelIndex: number) => void = null;


	public AddOnCompleteCallback(callback: () => void) {
		this.onCompleteCallbacks.push(callback);
	}

	private OnIdleBegin() {
		//this.OnComplete();
	}

	private OnFinishedBegin() {
		this.OnComplete();
	}

	private OnComplete(): void {
		for (let i = 0; i < this.onCompleteCallbacks.length; i++) {
			this.onCompleteCallbacks[i]();
		}
	}


	// public AddOnAnticipationBeginCallback(callback: () => void) {
	// 	this.onAnticipationBeginCallbacks.push(callback);
	// }

	// private OnAnticipationBegin() {
	// 	for (let i = 0; i < this.onAnticipationBeginCallbacks.length; i++) {
	// 		this.onAnticipationBeginCallbacks[i](new AnticipationParams(this.reelIndex));
	// 	}
	// }

	// public AddOnAnticipationEndCallback(callback: () => void) {
	// 	this.onAnticipationEndCallbacks.push(callback);
	// }

	// private OnAnticipationEnd() {
	// 	for (let i = 0; i < this.onAnticipationEndCallbacks.length; i++) {
	// 		this.onAnticipationEndCallbacks[i](new AnticipationParams(this.reelIndex));
	// 	}
	// }

	public OnPreviousReelSpinEnd() {
		// when previous reel stops spinning, this reel can begin decceleration
		// Log.Debug(this.logGroup, "Previous reel spin has ended");

		this.previousReelSpinEnded = true;

		// previous reel has ended, now this reel can enter anticipation state, or deccelerate, whatever
		//this.constantSpeed.SetDefaultDistance(this.symbolSize.height, true);
	}

	private onSpinEndCallbacks: (() => void)[] = [];
	public AddSpinEndCallback(callback: () => void) {
		this.onSpinEndCallbacks.push(callback)
	}

	public RequestStop(): void {

		if (this.targetSet) {
			if (!this.stopRequest) {

				// everything is ready for early stop, set new target distance
				// console.log(`reel ${this.reelIndex} Stop requested`);
				this.stopRequest = true;

                // end early
				//let constantSpeedTargetDistance = Math.ceil(this.constantSpeed.currentDistance / this.symbolSize.height) * this.symbolSize.height;
				this.constantSpeed.TryEnd(this.symbolSize.Height, true);

				// if we're in anticipation state, also end that
				//if (this.state == ReelSpinAnimState.Anticipation) {
				let anticipationTargetDistance = Math.ceil(this.anticipation.currentDistance / this.symbolSize.Height) * this.symbolSize.Height;
				this.anticipation.SetTargetDistance(anticipationTargetDistance);

				//this.speedFactor = this.acceleratedSpeedFactor;
				this.warpSpeedAnim.restart();
				//}
			}
			else {
				// console.log(`reel ${this.reelIndex} Already requested`);
			}
		}
		else {
			// console.log(`reel ${this.reelIndex} Stop not yet available`);
		}
	}

	public SetTarget(target: SpinTargetParams): void {

		// Log.Debug(this.logGroup, "Target set, anticipation: " + target.anticipation);
		this.targetSet = true;

        if (this.reelIndex <= 0)
        {
            // first reel has no anticipation
            return;
        }

        
		// setup anticipation, delay constant speed on later wheels
		if (target.anticipation && target.firstAnticipationReelIndex <= this.reelIndex)
		{
			this.reqAnticipation = true;

			let anticipationIndex = this.reelIndex - target.firstAnticipationReelIndex;
			let anticipationDelayDistance = this.anticipation.defaultDistance * (anticipationIndex);

			let calculatedTargetDistance = Math.ceil(this.constantSpeed.currentDistance / this.symbolSize.Height) * this.symbolSize.Height;
			
			// can't make target smaller than target distance already set
			let newTargetDistance = Math.max(calculatedTargetDistance, this.constantSpeed.defaultDistance);

			this.constantSpeed.SetTargetDistance(newTargetDistance + anticipationDelayDistance, this.symbolSize.Height);
		}
		else
		{
			let calculatedTargetDistance = Math.ceil(this.constantSpeed.currentDistance / this.symbolSize.Height) * this.symbolSize.Height;
			
			// can't make target smaller than target distance already set
			let newTargetDistance = Math.max(calculatedTargetDistance, this.constantSpeed.defaultDistance);

			this.constantSpeed.SetTargetDistance(newTargetDistance + this.constantSpeed.delayDistance, this.symbolSize.Height);
		}
	}

	public GetDistance(): number {
		return this.distance;
	}

	public AddOnStartCallback(callback: () => void): void {
		this.onStartCallbacks.push(callback);
	}

	private OnAccelerationBegin() {
		for (let i = 0; i < this.onStartCallbacks.length; i++) {
			this.onStartCallbacks[i]();
		}

		this.startTime = this.Now();
	}

	// decceleration
	private onDeccelerationStartedCallbacks: ((onDeccelerationParams: OnDeccelerationParams) => void)[] = [];

	private OnDeccelerationBegin() {

		let totalDistance = this.lastStateDistance + this.decceleration.targetDistance;
		let params: OnDeccelerationParams = new OnDeccelerationParams(
			totalDistance,
			Math.floor(totalDistance / this.symbolSize.Height)
		);

		for (let i = 0; i < this.onDeccelerationStartedCallbacks.length; i++) {
			this.onDeccelerationStartedCallbacks[i](params);
		}

		this.nearCompleteDistance = this.lastStateDistance + this.nearCompleteTargetDistance;
	}

	public AddOnDeccelerationCallbak(callback: (onDeccelerationParams: OnDeccelerationParams) => void): void {
		this.onDeccelerationStartedCallbacks.push(callback);
	}
	public UpdateSpinSpeed(speedParams: SpinAnimParams)
	{
		this.CalculateAnimation(speedParams.Duration,speedParams.Delay,speedParams.SpeedCorrection);
	}
}
